import * as React from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import { initializeIcons } from '@uifabric/icons';
import { loadTheme } from 'office-ui-fabric-react';
import hubService from '../../api/services/hub';
import { useDispatch } from 'react-redux';
import { getTeamEvent, getTeamEvents } from '../../store/Meeting/actions';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { useHistory } from 'react-router';
import Loader from '../../components/Loader';
import styles from './index.module.scss';
import { PrimaryButton } from '@fluentui/react';
import { Redirect } from "react-router-dom";

loadTheme({
    palette: {
        themePrimary: '#6264A7'
    }
});

initializeIcons();
export default (props: { children?: React.ReactNode }) => {
    const [initialize, setInitialize] = React.useState(false);
    const [adminConsent, setConsent] = React.useState(true);
    const [ChantId, setChatId] = React.useState("");
    const [tenantId, setTenantId] = React.useState("");
    let history = useHistory();
    const {
        teamEvent
    } = useTypedSelector((state: ApplicationState) => state.meeting);


    const onAdminConsentClick = (tid: string | undefined, chatId: string | undefined) => {
        const state = new Date().getTime();
        microsoftTeams.authentication.authenticate({
            url: `${window.location.origin}/auth-start?state=${state}&tId=${tid}`,
            width: 600,
            height: 535,
            successCallback: () => {
                microsoftTeams.authentication.getAuthToken({
                    successCallback: (token: string) => {
                        localStorage.setItem("teams_token", token);
                        hubService.exchangeToken(tid as string, token).then(response => {
                            setConsent(true);
                            localStorage.setItem("graph_token", response.value.access_token);
                            dispatch(getTeamEvent(chatId as string));
                            dispatch(getTeamEvents(new Date()));
                        });
                    },
                    failureCallback: () => {
                        setInitialize(true);
                    }
                })
            },
            failureCallback: () => {
                setInitialize(true);
            }
        });
    }

    const dispatch = useDispatch();
    React.useEffect(() => {
        if (history.location.pathname.indexOf("/login") >= 0) {
            setInitialize(true);
            return;
        }
        microsoftTeams.initialize(() => {
            microsoftTeams.getContext(({ tid, chatId, ...rest }) => {
                var url = window.location.href;
                if(url.indexOf("auth-end") > -1)
                {
                    window.close();
                }

                microsoftTeams.authentication.getAuthToken({
                    successCallback: (token: string) => {
                        localStorage.setItem("teams_token", token);
                        hubService.exchangeToken(tid as string, token).then(response => {
                            if (response && response.value) {
                                const scope: string = response.value.scope;
                                if (scope && scope.toLocaleLowerCase().indexOf("calendars.read") >= 0) {
                                    setConsent(true);
                                    // now you have calendars read permission. Get calendar event
                                    localStorage.setItem("graph_token", response.value.access_token);
                                    dispatch(getTeamEvent(chatId as string));
                                    dispatch(getTeamEvents(new Date()));
                                } else {
                                    setConsent(false);
                                    let tempChant = (chatId != undefined) ? chatId : "";
                                    let tempTid = (tid != undefined) ? tid : "";
                                    setChatId(tempChant);
                                    setTenantId(tempTid);
                                }
                            }
                            else {
                                setConsent(false);
                                let tempChant = (chatId != undefined) ? chatId : "";
                                let tempTid = (tid != undefined) ? tid : "";
                                setChatId(tempChant);
                                setTenantId(tempTid);
                               
                            }
                        })

                    },
                    failureCallback: () => {
                        setInitialize(true);
                    }
                })
               
            });

        });
    }, []);
    React.useEffect(() => {
        if (teamEvent !== null) {
            setInitialize(true);
        }
    }, [teamEvent && teamEvent.id])
    return (
        <React.Fragment>
            {adminConsent && !initialize && <div className={styles.loader}><Loader /></div>}
            {!adminConsent && <div> You admin has not consented permissions yet, if you are admin <PrimaryButton className={styles.btn} onClick={() => onAdminConsentClick(tenantId, ChantId)}>Click Here</PrimaryButton>
                <br/>
                    Note:Refresh the page after consenting.
                                </div>}
            {adminConsent && initialize && props.children}
        </React.Fragment>
    );

} 